import { DateTime } from 'luxon';
import { FilterDTO } from '../models/models.swagger.generated';
import { DateHelper } from './date-helper';

export class FilterUtil {
  public static FindAllFiltersWithSpecificField(fieldName: string, filters: FilterDTO[]): FilterDTO[] {
    const resFilters: FilterDTO[] = [];
    if (filters) {
      filters.forEach((f) => {
        const subFilters = FilterUtil.FindAllFiltersWithSpecificFieldInFilter(fieldName, f);
        if (subFilters.length) {
          resFilters.push(...subFilters);
        }
      });
    }
    return resFilters;
  }

  public static FindAllFiltersWithSpecificFieldInFilter(fieldName: string, filter: FilterDTO): FilterDTO[] {
    const filters: FilterDTO[] = [];
    if (filter.isComplex) {
      if (filter.predicates) {
        const subFilters = FilterUtil.FindAllFiltersWithSpecificField(fieldName, filter.predicates);
        if (subFilters.length) {
          filters.push(...subFilters);
        }
      }
    } else if (filter.field?.toLocaleLowerCase() === fieldName.toLocaleLowerCase()){
      filters.push(filter);
    }
    return filters;
  }

  public static correctDateTimeFilters(filters: FilterDTO[], fieldName: string, timeZone: string | luxon.Zone) {
    if (!filters) {
      return;
    }
    const filtersToCorrect = FilterUtil.FindAllFiltersWithSpecificField(fieldName, filters);
    filtersToCorrect.forEach(f => {
      if (f.value) {
        f.value = DateHelper.migrateTimeZone(DateTime.fromISO(f.value), timeZone);
      }
    });
  }

  public static replaceFieldNameInfilters(filters: FilterDTO[], oldFieldName: string, newFieldName: string) {
    if (!filters) {
      return;
    }
    const filtersToCorrect = FilterUtil.FindAllFiltersWithSpecificField(oldFieldName, filters);
    filtersToCorrect.forEach(f => {
      f.field = newFieldName;
    });
  }
}
